import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Portal } from '@material-ui/core';
import { Form } from 'react-final-form';
import styled from 'styled-components';
import OutlinedFormTextField from 'components/Form/FinalForm/OutlinedFormTextField';
import OutlinedFormPasswordField from 'components/Form/FinalForm/OutlinedFormPasswordField';
import { composeValidators, required, validateEmail, minLength, maxLength } from '../../../../utils/validators';
import { useDispatch, useSelector } from 'react-redux';
import { closeLinkAccountDialog } from '../../../../actions';
import { useLinkAccountMutation } from '../../../../services/api/auth';

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const StyledButton = styled(Button)`
  && {
    border-radius: 8px;
    text-transform: none;
  }

  &:disabled {
    background: #005a96;
    opacity: 0.5;
    color: #fff;
  }
`;

const emailFieldValidation = composeValidators(required, validateEmail);
const passwordFieldValidation = composeValidators(required, minLength(6), maxLength(25));

const LinkAccountDialog = () => {
  const [linkMutation, { isLoading }] = useLinkAccountMutation();

  const onSubmit = values => {
    linkMutation(values);
  };

  const isOpen = useSelector(state => state.user.linkAccountDialogOpened);

  const dispatch = useDispatch();

  const close = () => {
    dispatch(closeLinkAccountDialog());
  };

  return (
    <Dialog open={isOpen} onBackdropClick={close} maxWidth="sm" fullWidth>
      <DialogTitle>Link Account</DialogTitle>
      <Form initialValues={{ email: '', password: '' }} onSubmit={onSubmit}>
        {props => {
          const disableSubmitButton = props.hasSubmitErrors || props.pristine || isLoading;
          return (
            <StyledForm onSubmit={props.handleSubmit}>
              <DialogContent>
                <OutlinedFormTextField
                  name="email"
                  validate={emailFieldValidation}
                  type="email"
                  placeholder="John.smith@gmail.com"
                  label="E-mail*"
                />
                <OutlinedFormPasswordField validate={passwordFieldValidation} />
              </DialogContent>
              <DialogActions>
                <Button onClick={close} color="primary">
                  Cancel
                </Button>
                <StyledButton disabled={disableSubmitButton} variant="contained" color="primary" type="submit">
                  Link Account
                </StyledButton>
              </DialogActions>
            </StyledForm>
          );
        }}
      </Form>
    </Dialog>
  );
};

export default LinkAccountDialog;
